// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__tFUmf","consentsList":"PatientConsents_consentsList__i_H0P","consentsListEmpty":"PatientConsents_consentsListEmpty__3Ij0n"};